import { render, staticRenderFns } from "./PathActivityCommentsSection.vue?vue&type=template&id=db2054da&scoped=true&"
import script from "./PathActivityCommentsSection.vue?vue&type=script&lang=js&"
export * from "./PathActivityCommentsSection.vue?vue&type=script&lang=js&"
import style0 from "./PathActivityCommentsSection.vue?vue&type=style&index=0&id=db2054da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2054da",
  null
  
)

export default component.exports